export default __webpack_public_path__ + "static/media/backKick.e1aeb535.png";